export default __webpack_public_path__ + "static/media/ellipse-green.a06c476f.svg";